// extracted by mini-css-extract-plugin
module.exports = {"List":"Tabs_List__2rLJG","Item":"Tabs_Item__2T3-i","ItemDisabled":"Tabs_ItemDisabled__27Gwo","ItemSelected":"Tabs_ItemSelected__XIrOD"};